import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jaNeinPipe'
})
export class JaNeinPipe implements PipeTransform {
  transform(value: boolean): string {
    return value ? 'Ja' : 'Nein';
  }
}
